import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import DateForm from "../../Components/DateForm/DateForm";
import InputForm from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import {
  getPostPaymentDetails,
  insertIntoMemberEnrollmentHistory,
} from "../../Helpers/APIEndPoints/EndPoints";
import notify from "../../Helpers/ToastNotification";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import VerifyModal from "../Common/VerifyModal/VerifyModal";
import { RiFileListLine } from "react-icons/ri";
import { Modules } from "../../Helpers/Enums/Modules";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";

const PaymentVerificationView = () => {
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { state } = useLocation();
  let navigate = useNavigate();

  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const [comment, setComment] = useState("");
  const [approve, setApprove] = useState(false);
  const [reject, setReject] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showHideButton, setShowHideButton] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const open = Boolean(anchorEl);

  const memberid = state?.id || GetDecryptedMemberIdFromLocalStorage() || "";

  const [data, setData] = useState({
    initialDeposit: null,
    monthlyDeductions: null,
    totalPayable: null,
    accholdername: "",
    bankName: "",
    ifsc: "",
    transactionRef: null,
    amount: null,
    transactionDate: null,
    typeoftransaction: null,
  });

  const transactionOption = [
    { label: "IMPS", value: "IMPS" },
    { label: "RTGS", value: "RTGS" },
    { label: "NEFT", value: "NEFT" },
  ];

  const onChange = (key, value) => {
    setData({ ...data, [key]: value });
  };

  useEffect(() => {
    (async () => await getPaymentDetailsByMemberId())();
  }, []);

  const getPaymentDetailsByMemberId = async () => {
    showLoader();

 

    if (state != null && state != "") {
      let memberid = state?.id;

      setShowHideButton(state?.ShowHideButton);

      if (memberid != null && state != "") {
        // let payment = `${getPostPaymentDetails}/${memberid}`;

        // const getpayment = await APICall(payment, {}, HttpMethod.GET);

        let requestParams = { MemberId: memberid };
        const res = await APICall(getPostPaymentDetails, requestParams);

        if (res.Message === "Ok" && res.Data !== null) {
          let obj = {
            initialDeposit: res.Data.InitialDeposit,
            monthlyDeductions: res.Data.MonthlyDeductions,
            totalPayable: res.Data.TotalPayable,
            accholdername: res.Data.AccountHolderName,
            bankName: res.Data.BankName,
            ifsc: res.Data.IFSCCode,
            typeoftransaction: transactionOption.find(
              (d) => d.value === res.Data.TxnType
            ),
            transactionRef: res.Data.TxnReferenceNo,
            amount: res.Data.Amount,
            transactionDate: res.Data.TxnDate,
          };

          setData(obj);
          setDisabled(true);
          hideLoader();
        } else {
          notify(1, "No data found");
          setDisabled(true);
          setShowHideButton(true);
          hideLoader();
        }
      } else {
        notify(1, "No data found");
        setDisabled(true);
        setShowHideButton(true);
        hideLoader();
      }
    } else {
      notify(1, "Something went wrong");
      setDisabled(true);
      hideLoader();
    }

    hideLoader();
  };

  const closeVerifyModal = (confirmation) => {
    setShowVerifyModal(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* {!showHideButton && (
        <div className="d-flex justify-content-end mt-4">
          <div className="float-right px-3 py-2">
            <ButtonComponent
              icon={""}
              value={"Verify"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={() => setShowVerifyModal(true)}
            />
          </div>
        </div>
      )} */}

      <div className="clearfix"></div>

      <div className="">
        <div className="col-lg-12 col-md-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Initial Deposit</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.initialDeposit}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Monthly Deduction</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.monthlyDeductions}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Total Payable</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.totalPayable}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Account Holder Name</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.accholdername}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("accholdername", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Bank Name</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.bankName}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("bankName", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>IFSC Code</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.ifsc}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("ifsc", value);
                  }}
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Type of Transaction</label>
                <sup>*</sup>
                <SelectForm
                  value={data.typeoftransaction}
                  placeholder=""
                  options={transactionOption}
                  isDisabled={disabled}
                  onChange={(val: any) => onChange("typeoftransaction", val)}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Transaction Reference No</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.transactionRef}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("transactionRef", value);
                  }}
                  type=""
                  isDisabled={disabled}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Amount</label>
                <sup>*</sup>
                <InputForm
                  placeholder={""}
                  value={data.amount}
                  onChange={(val: any) => {
                    let value = val.target.value;
                    onChange("amount", value);
                  }}
                  type="number"
                  isDisabled={disabled}
                  onWheel={(e) => e.target.blur()}
                />
                {/* {error[data.guardianaddress] && (
              <p style={{ color: "red" }}>{error[data.guardianaddress]}</p>
            )} */}
              </div>
            </div>
            
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group">
                <label>Transaction Date</label>
                <sup>*</sup>
                <DateForm
                  isDisabled={disabled}
                  value={data.transactionDate}
                  onChange={(val: any) => onChange("transactionDate", val)}
                />
                {/* {error[data.dob] && (
              <p style={{ color: "red" }}>{error[data.dob]}</p>
            )} */}
              </div>
            </div>
          </div>
          {/* <div className="d-flex justify-content-end">
        <ButtonComponent  icon={"fas fa-arrow-left"} value={"Back" } style={{marginRight:"20px"}}  onClick={previous} />
        <ButtonComponent icon={"fas fa-arrow-right"} value={"Save"} id={"saveBtn"} onClick={onPyamentInsert} />

      </div> */}
        </div>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <div>
          <ButtonForm
            className="mx-2"
            id="cancel"
            value={<p><i className="far fa-times-circle"></i> Cancel</p> }
            onClick={() => navigate("/PaymentVerification")}
          />
          {state?.action !== "View" ? (
            <ButtonComponent
              icon={"fas fa-check-double"}
              value={"Verify"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              //onClick={() => setShowVerifyModal(true)}
              onClick={handleClick}
            >
             
            </ButtonComponent>
          ) : (
            ""
          )}
        </div>
      </div>
      <>
        {/* <Modal
          show={showVerifyModal}
          onHide={() => closeVerifyModal(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
          centered
        >
          <Modal.Body>
            <div className="col-lg-12 col-md-12">
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-xs-6">
                  <div className="">
                    <input
autoComplete={AutoCompleteValue}
                      placeholder={""}
                      value={""}
                      onChange={(val: any) => {
                        let value = val.target.checked;
                        onChangeVerify("approve", value);
                      }}
                      type="radio"
                      name="varificarion"
                    />{" "}
                    <span style={{ marginLeft: "12px" }}>Approve</span>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-6">
                  <div className="">
                    <input
autoComplete={AutoCompleteValue}
                      placeholder={""}
                      value={""}
                      onChange={(val: any) => {
                        let value = val.target.checked;
                        onChangeVerify("reject", value);
                      }}
                      type="radio"
                      name="varificarion"
                    />{" "}
                    <span style={{ marginLeft: "12px" }}>Reject</span>
                  </div>
                </div>
              </div>
              <br />
              {!hideShowComment && (
                <div className="row">
                  <div className="col-lg-12 col-sm-12 col-xs-12 ">
                    <div className="form-group">
                      <label>Comments</label> 
                      <InputForm
                        placeholder={""}
                        value={comment}
                        textArea={true}
                        onChange={(val: any) => {
                          let value = val.target.value;
                          onChangeVerify("comment", value);
                        }}
                      />
                    </div>
                    {error[comment] && (
                      <p style={{ color: "red" }}>{error[comment]}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-cancel"
              style={{ marginLeft: 5 }}
              onClick={() => closeVerifyModal(false)}
            >
              Cancel
            </button>
            <ButtonComponent
              icon={""}
              value={"Submit"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={() => onSubmit()}
            />
          </Modal.Footer>
        </Modal>*/}
        <VerifyModal
          open={open}
          anchorEl={anchorEl}
          handleClose={handleClose}
          memberid={memberid}
          module={Modules.PaymentVerification}
        />
      </>
    </>
  );
};

export default PaymentVerificationView;
 {/* No Chnages< */}
 {/* No Chnages< AS*/}